import React from "react";
import { Container, Grid } from "@mui/material";
import WelcomeCard from "../CMS/WelcomeCard";
import SurveyCard from "./Survey/SurveyCard";
import QuestionnaireCard from "./Questionnaire/QuestionnaireCard";
import BreadcrumbBuilder from "./BreadcrumbBuilder";

function Dashboard() {
    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard appCode={"C-MSF"} />
                </Grid>

                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <SurveyCard />
                </Grid>

                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <QuestionnaireCard />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Dashboard;
